import { useState, useRef, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";

type Props = {
  url: string;
  label?: string;
};

export function QRDropdown({ url, label = "QR" }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function handler(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-50"
      >
        {label}
      </button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-52 rounded-2xl border border-gray-100 bg-white p-4 shadow-xl">
          <div className="flex justify-center">
            <QRCodeSVG value={url} size={160} level="M" />
          </div>
          <p className="mt-3 break-all text-center font-mono text-[10px] leading-tight text-gray-400">
            {url}
          </p>
        </div>
      )}
    </div>
  );
}
